import { createStore, Store } from "vuex";
import { RootState } from "@/store/types";
import { SubLink } from "@/types";
// define your typings for the store state

// Create a new store instance.
export const store = createStore<RootState>({
  state() {
    return {
      token: "",
      user: "",
      isAuthenticated: false,
      isAdmin: false,
      currentLinks: [
        { title: "Home", name: "home", id: 1 },
        { title: "Information", name: "info", id: 2 },
        { title: "Bujinkan", name: "bujin", id: 3 },
        { title: "Seminar", name: "seminar", id: 4 },
      ],
    };
  },
  actions: {
    addUser(context, userName: string) {
      context.commit("addUser", userName);
    },
    addToken(context, receivedToken: string) {
      context.commit("addToken", receivedToken);
    },
    addAdminCheck(context, adminState: boolean) {
      context.commit("addAdminCheck", adminState);
    },
    removeUser(context) {
      context.commit("removeUser");
    },
    updateLinks(context, newLinks: Array<SubLink>) {
      context.commit("updateLinks", newLinks);
    },
  },
  mutations: {
    addUser(state, name): void {
      if (name !== "") {
        state.user = name;
      } else {
        alert("missing username");
      }
    },
    addToken(state, receivedToken): void {
      if (receivedToken !== "") {
        state.token = receivedToken;
        state.isAuthenticated = true;
      } else {
        alert("missing token");
      }
    },
    addAdminCheck(state, adminState): void {
      if (adminState === true) {
        state.isAdmin = true;
      } else {
        state.isAdmin = false;
      }
    },
    removeUser(state): void {
      state.user = "";
      state.token = "";
      state.isAuthenticated = false;
    },
    updateLinks(state, newLinks): void {
      state.currentLinks = newLinks;
    },
  },
  getters: {
    getUser(state): string {
      return state.user;
    },
    getToken(state): string {
      return state.token;
    },
    getAuthState(state): boolean {
      return state.isAuthenticated;
    },
    getAdminState(state): boolean {
      return state.isAdmin;
    },
    getLinks(state): Array<SubLink> {
      return state.currentLinks;
    },
  },
});
